import api from "../api";

export const getFeatures = async () => {
      return await api
        .get(`/feature`)
        .catch((err) => console.error(err));
  }
